import { ROLES_SIN_IMPORTES } from "@/utils/roles";

// Compatibilidad segura para sesiones antiguas sin mapa de permisos.
const ROLE_FEATURES = {
	anfitrion: "*",
	gestor: "*",

	// 🚨 El PROPIETARIO ve su calendario y sus analíticas. Y nada más.
	//
	// Esto ya decía eso, pero «Llamadas», «Soporte», «Inicio», «Mi cuenta» y
	// «Página web» le salían igual: esas entradas del menú NO preguntaban. Una
	// miraba si la cuenta tenía contratado el servicio de voz, otras no miraban
	// nada. Cada una decidía por su cuenta y el reparto estaba al revés —visible
	// salvo que alguien se acordara de ponerle llave—, así que cualquier entrada
	// nueva entraba en todos los menús por omisión.
	//
	// ⚠️ `account`, `website`, `support` y `voice_calls` son llaves SOLO DE MENÚ:
	// el backend no las conoce porque no protegen datos de la cuenta, solo deciden
	// qué puerta se enseña. Las de verdad —las que el servidor comprueba en cada
	// petición— son las de arriba y están en TeamPermissions::FEATURES.
	//
	// El propietario no tiene ninguna de las cuatro. «Mi cuenta» además cuelga de
	// la facturación del TITULAR, que es la última pantalla que debe ver alguien
	// que solo es dueño de un apartamento.
	propietario: ["analytics", "calendar"],

	// 🚨 El COANFITRIÓN lleva la casa igual que el anfitrión, pero NO VE DINERO.
	//
	// O sea: todo el día a día —reservas, calendario, huéspedes, mensajes, anuncios,
	// canales, recepcionista, limpieza— y fuera «analytics» (son ingresos de principio
	// a fin) y «invoicing» (una factura es un importe con membrete).
	//
	// Tampoco `account` ni `website`: la primera cuelga de la facturación del TITULAR
	// y la segunda edita la web pública del negocio. Sí `support` y `voice_calls`, que
	// son herramientas del día a día.
	//
	// ⚠️ Esta lista es un ESPEJO de TeamPermissions::PRESETS['coanfitrion'] del
	// servidor, que se calcula como «todas menos SIN_IMPORTES». Aquí hay que
	// escribirla a mano porque `hasFeature` no lee `subUser.permissions` (ver abajo).
	// Si mañana se añade una función al backend, hay que añadirla también aquí.
	coanfitrion: [
		"dashboard", "calendar", "reservations", "bookings", "guests", "messages",
		"properties", "services", "channel_manager", "ai_agent", "direct_bookings",
		"housekeeping", "support", "voice_calls",
	],

	// `website` no lo lleva NADIE salvo el titular y el gestor: el constructor
	// edita la web pública del negocio. `voice_calls` sí lo lleva recepción, que
	// es literalmente de quien es el teléfono.
	limpieza: ["dashboard", "housekeeping", "messages", "account", "support"],
	mantenimiento: ["dashboard", "housekeeping", "messages", "account", "support"],
	recepcion: ["dashboard", "calendar", "reservations", "bookings", "guests", "messages", "account", "support", "voice_calls"],
};

const getters = {
	loggedIn(state) {
		return state.token !== null
	},

	// ¿El usuario actual puede usar la función `key`?
	// - Anfitrión (sin subUser) → siempre true.
	// Los perfiles son fijos: no confiamos en mapas de permisos antiguos que
	// pudieran dejar visible una función retirada del rol.
	hasFeature: (state) => (key) => {
		const su = state.subUser;
		if (!su) return true;

		const allowed = ROLE_FEATURES[su.sub_role];
		if (allowed === "*") return true;
		return Array.isArray(allowed) && allowed.includes(key);
	},


	/**
	 * ¿Hay que esconderle los importes a quien está mirando?
	 *
	 * 🚨 Es la ÚNICA pregunta que debe hacerse una pantalla para decidir si tapa
	 * dinero. Antes de esto, cada sitio se inventaba su propia comprobación
	 * (`isPropietario` en el calendario, `restricted` en gestión…) y por eso el
	 * reparto acababa distinto en cada pantalla.
	 *
	 * ⚠️ Esto es solo para que no quede un hueco feo: **lo que de verdad protege es
	 * el servidor**, que ya no manda los importes a este perfil
	 * (`App\Http\Middleware\OcultarImportes`). Esconderlo solo aquí sería cosmético,
	 * porque el precio se leería abriendo la pestaña de red del navegador.
	 */
	ocultaImportes: (state) => {
		const su = state.subUser;
		if (!su) return false; // el anfitrión ve su dinero
		return ROLES_SIN_IMPORTES.includes(su.sub_role);
	},
}

export default getters
